<section
  class="box-border flex justify-between items-start px-4 lg:px-6 xl:px-8 py-4 sm:py-6 md:py-8 w-full my-0 max-md:flex-col gap-4 sm:gap-6 md:gap-8 lg:gap-12">
  <!-- Left side: Title, subtitle, and link -->
  <div class="flex flex-col gap-3 sm:gap-6 items-start w-full md:w-5/12 lg:w-4/12 shrink-0">
    <header class="flex flex-col gap-1.5 sm:gap-3 items-start w-full">
      <h2 class="text-2xl sm:text-3xl font-bold leading-tight text-black">
        Frequently Asked Questions
      </h2>
      <p class="w-full text-base sm:text-lg text-gray-600 leading-normal">
        Get all your answers related to circularity
      </p>
    </header>
    <button type="button" class="flex gap-1 items-center rounded-xl max-sm:hidden transition-colors"
      (click)="handleViewAllFaqs($event)">
      <span class="text-base font-bold leading-5 text-blue-500 hover:text-blue-700">
        View All FAQ's
      </span>
    </button>
  </div>

  <!-- Right side: FAQ items -->
  <div class="flex flex-col w-full md:w-7/12 lg:w-8/12 divide-y divide-gray-200">
    <article *ngFor="let faq of faqItems; let i = index; trackBy: trackByFaq"
      class="flex flex-col gap-3 items-start px-0 py-4 w-full bg-white">
      <header class="flex gap-6 justify-between items-center w-full cursor-pointer select-none"
        (click)="toggleExpanded(i)">
        <h3 class="FAQQuestion flex-1 text-base sm:text-lg font-bold leading-snug text-black">
          {{ faq.question }}
        </h3>
        <div
          class="flex justify-center items-center shrink-0 p-1.5 w-8 h-8 rounded-full shadow-[0_1px_4px_rgba(0,0,0,0.12)] border border-gray-100">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
            [ngClass]="{ 'rotate-180': faq.expanded }" class="transition-transform duration-300">
            <path d="M5 7.5L9.41074 11.9107C9.73618 12.2362 10.2638 12.2362 10.5893 11.9107L15 7.5" stroke="black"
              stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </header>

      <section
        class="FAQAnswer text-sm sm:text-base leading-relaxed text-gray-600 pl-0 pr-8 overflow-hidden transition-all duration-300 ease-in-out"
        [ngClass]="
          faq.expanded ? 'max-h-96 opacity-100 pt-2' : 'max-h-0 opacity-0'
        ">
        <p>{{ faq.answer }}</p>
      </section>
    </article>
  </div>

  <div class="w-full sm:hidden flex justify-center mt-4">
    <button
      class="flex justify-center items-center px-4 py-2 rounded-lg border border-blue-600 text-blue-600 font-bold text-sm hover:bg-blue-50 transition-colors"
      type="button" (click)="handleViewAllFaqs($event)">
      View All FAQ's
    </button>
  </div>
</section>